import * as yup from 'yup';

export const validateAdditionalInfoForm = yup.object({
  program: yup.string(),
  preferredSurgeonName: yup.string(),
  preferredCardiologistName: yup.string(),
  whyChoose: yup.string(),
  hospitalName: yup.string()
});
